/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Nothing_To_CutInputs */



/**
* | output |
* | --- |
* | "Nothing to cut" |
*
* @param {Spaces_Nothing_To_CutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_nothing_to_cut = /** @type {((inputs?: Spaces_Nothing_To_CutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Nothing_To_CutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nichts zum Ausschneiden")
	return /** @type {LocalizedString} */ ("Nothing to cut")
});